import {Component, OnInit} from '@angular/core';
import { SocialAuthService} from "@abacritt/angularx-social-login";
import {AuthService} from "../../../shared/services/auth.service";
import {MessageService} from "primeng/api";
import {Router} from "@angular/router";
import {toastConfig} from "../../interceptors/error.interceptor";
import {Subject} from "rxjs";

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  destroy$: Subject<any> = new Subject<any>();

  constructor (
    private readonly socialAuthService: SocialAuthService,
    private readonly authService: AuthService,
    private readonly toaster: MessageService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
  }

  logout() {
    let userInfo = JSON.parse(localStorage.getItem('userEmail')!);
      this.socialAuthService.signOut(true).then(() => {
        this.afterSignOut(userInfo);
      }).catch((er) => {
        this.afterSignOut(userInfo)
      });

  }

  afterSignOut(userInfo: any) {
    localStorage.removeItem('authorizationData');
    this.router.navigate(['/login']);

    setTimeout(() => {
      this.toaster.add({
        severity: 'success',
        summary: 'Logout Success',
        detail: 'Logged Out Of Application',
        ...toastConfig
      });
    }, 1000);
    //this.authService.logout(userInfo).subscribe(() => {  })
  }

  ngOnDestroy(): void {
    this.destroy$.next('');
    this.destroy$.complete();
  }

}
